import { observer } from "mobx-react-lite";
import { Icon, Message, Table } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { useEffect } from "react";
import { useStore } from "../../app/stores/store";
import { PagingParams } from "../../app/models/pagination";
import MyPaging from "../../app/common/form/MyPaging";
import { ImportLogs } from "../../app/models/systemAdmin";

export default observer(function ImportLogs() {
  const { t } = useTranslation(["common"]);
  const { importsLogStore } = useStore();

  const {
    loadImportLogs,
    getImportLogs,
    pagination,
    setPagingParams,
    pagingParams,
  } = importsLogStore;

  useEffect(() => {
      loadImportLogs();
  }, [
    loadImportLogs,
  ]);

  function listOnClick(value: number) {
    if (value > 0 && pagination && value < pagination?.totalPages + 1) {
      setPagingParams(new PagingParams(value));
      loadImportLogs();
    }
  }

  function getIcon(x: ImportLogs) {
    if (x.success === true) {
      return <Icon name="check" color="green" />
    }
    if (x.success === false) {
      return <Icon name="x" color="red" />
    }

    return <></>;
  }

  return (
    <Table celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Company Id</Table.HeaderCell>
          <Table.HeaderCell>Date Created</Table.HeaderCell>
          <Table.HeaderCell>Converted Date</Table.HeaderCell>
          <Table.HeaderCell>Started Date</Table.HeaderCell>
          <Table.HeaderCell>Completed Date</Table.HeaderCell>
          <Table.HeaderCell>Last Activity</Table.HeaderCell>
          <Table.HeaderCell>Success</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {getImportLogs && getImportLogs.length > 0 ? (
          getImportLogs.map((x: ImportLogs) => (
            <Table.Row key={x.id}>
              <Table.Cell>
                <Link 
                  to={`/admin/company/${x.clientId}`}
                >
                  {x.companyName}
                </Link>
              </Table.Cell>
              <Table.Cell>{format(x.createdDate, "P p")}</Table.Cell>
              <Table.Cell>{x.convertedDate && format(x.convertedDate, "P p")}</Table.Cell>
              <Table.Cell>{x.startDate && format(x.startDate, "P p")}</Table.Cell>
              <Table.Cell>{x.completedDate && format(x.completedDate, "P p")}</Table.Cell>
              <Table.Cell>{x.lastActivity && format(x.lastActivity, "P p")}</Table.Cell>
              <Table.Cell>{getIcon(x)}</Table.Cell>
            </Table.Row>
          ))
        ) : (
          <Table.Row key={"noItems"}>
            <Table.Cell width="8" colSpan={8}>
              <Message
                color="yellow"
                className="textAlignCenter fontStyleItalic"
              >
                {t("grid_noItems", { ns: "common" })}
              </Message>
            </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
      <Table.Footer>
        <Table.Row>
          <Table.HeaderCell colSpan="8">
            <MyPaging
              itemCount={pagination ? pagination.totalItems : 10}
              pageSize={pagingParams.pageSize}
              currentPage={pagination ? pagination.currentPage : 1}
              onClick={listOnClick}
              onChange={listOnClick}
              floated="right"
            ></MyPaging>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
});
